import { Button, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TotalEstimatedSpendModal } from '@hero/components/modals';
import { FormatCurrencyWithState, LiveCostSummaryContent, ReviewSection } from '@hero/molecules';

import * as S from './style';

export function PricingSection({
  adjustedEstimatedCharge,
  refund,
  estimatedCharges,
  featureType,
  isCCPayment,
  isCompleted = false,
  isError,
  isLoadingFeature,
  isLoadingSpendingSummary,
  stepIndex = 6
}) {
  const { t } = useTranslation();

  const [isEstimatedModalOpen, setIsEstimatedModalOpen] = useState(false);

  const hasMinMaxEstimatedCharge =
    typeof minEstimatedCharge === 'number' && typeof maxEstimatedCharge === 'number';

  const hasEstimatedCharge = !!adjustedEstimatedCharge || !!hasMinMaxEstimatedCharge;

  return (
    <ReviewSection
      stepIndex={stepIndex}
      isCompleted={isCompleted}
      title={t('totalEstimatedSpend')}
      subTitle={
        <Button
          onClick={() => setIsEstimatedModalOpen(true)}
          variant="link"
          color="neutral"
          style={{ textTransform: 'none' }}
        >
          <Typography variant="caption1" color="neutral" emphasis="500">
            {t('howOurPriceWork')}
          </Typography>
        </Button>
      }
      headerChildren={
        <FormatCurrencyWithState
          isLoading={isLoadingSpendingSummary || (!hasEstimatedCharge && !refund)}
          value={adjustedEstimatedCharge?.total || estimatedCharges?.total}
          isNotAvailable={isError || !isCompleted}
          components={{
            BeforeNA: () => (
              <Typography variant="caption1" color="fg" emphasis="weak">
                ({t('addRecipientsToSeeTotal')})
              </Typography>
            )
          }}
        />
      }
    >
      {isCompleted && (
        <S.PricingSection>
          <LiveCostSummaryContent
            estimatedCharges={estimatedCharges}
            featureType={featureType}
            isCCPayment={isCCPayment}
            isError={isError}
            isLoadingFeature={isLoadingFeature}
            isLoadingSpendingSummary={isLoadingSpendingSummary}
          />
        </S.PricingSection>
      )}

      <TotalEstimatedSpendModal
        featureType={featureType}
        isCCPayment={isCCPayment}
        isModalOpen={isEstimatedModalOpen}
        onModalOpen={() => setIsEstimatedModalOpen(false)}
      />
    </ReviewSection>
  );
}

PricingSection.propTypes = {
  isCompleted: PropTypes.bool,
  stepIndex: PropTypes.number,
  estimatedCharges: PropTypes.shape({
    serviceCharge: PropTypes.number,
    total: PropTypes.number
  }),
  featureType: PropTypes.string,
  isCCPayment: PropTypes.bool,
  isError: PropTypes.bool,
  isLoadingFeature: PropTypes.bool,
  isLoadingSpendingSummary: PropTypes.bool
};
